// extracted by mini-css-extract-plugin
export var active = "_hd-7";
export var blink = "_hd-8";
export var dropDownSelector = "_hd-4";
export var dropDownWrapper = "_hd-3";
export var fakeCursor = "_hd-6";
export var fontSizeButton = "_hd-9";
export var formQuillEditor = "_hd-0";
export var pressed = "_hd-a";
export var qlBlank = "_hd-1";
export var textFormattingToolbar = "_hd-2";
export var textToolbarOption = "_hd-5";